<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="$t('notificationtemplates.title')"></page-header-title>

      <v-spacer></v-spacer>

      <v-form ref="form" @submit.prevent="filter" class="mt-8 d-none d-sm-flex">
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex xs6>
              <v-select
                v-model="search_params.type"
                :items="$dd_notification_template_type()"
                item-text="text"
                item-value="key"
                :label="$t('notificationtemplates.type')"
                @change="filter"
                hide-details
                clearable
              >
              </v-select>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                :label="$t('global.search')"
                v-model="search_params.any"
                @keydown="checkKeyPress"
                autocomplete="new-password"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>

      <!--<router-link
                :to="BACKEND_URL + '/notificationtemplates/create'"
                v-if="$can('notificationtemplate-create')"
            >
                <action-button type="new"/>
            </router-link>-->
    </v-app-bar>

    <v-card>
      <v-card-text>
        <v-flex md12>
          <v-data-table
            :headers="headers"
            :items="notificationtemplates"
            :items-per-page="notificationtemplates.length"
            :options.sync="pagination"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
              'items-per-page-all-text': $t('global.items_per_page_all_text'),
              'items-per-page-text': $t('global.items_per_page_text'),
              'page-text': $t('global.page_text')
            }"
            :server-items-length="total"
            :loading="show_loading"
            :loading-text="$t('global.loading_text')"
            :no-data-text="$t('global.no_data_text')"
            :no-results-text="$t('global.no_results_text')"
            :must-sort="true"
          >
            <template v-slot:item.type="{ item }">
              {{ $dd_notification_template_type(item.type) }}
            </template>

            <template v-slot:item.updated_at="{ item }">
              {{ item.updated_at ? moment.utc(item.updated_at).format(DATE_FORMAT + " " + TIME_FORMAT) : "" }}
            </template>

            <template v-slot:item.trigger="{ item }">
              {{ getTriggerName(item.trigger) }}
            </template>

            <template v-slot:item.actions="{ item }">
              <router-link
                :to="{
                  path: BACKEND_URL + '/notificationtemplates/edit/' + item.id,
                  props: { id: item.id }
                }"
              >
                <action-button type="edit" :icon_only="true" small />
              </router-link>

              <!--<action-button
                                type="delete"
                                @click="del(item.id)"
                                v-if="$can('notificationtemplate-delete')"
                                :icon_only="true"
                                small
                            />-->
            </template>
          </v-data-table>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "NotificationList",

  data() {
    return {
      url: "",

      notificationtemplates: [],
      triggers: [],

      total: 0,
      show_loading: false,
      show_filter: false,
      refresh: false,
      pagination: {
        page: this.$getLocalStorage("__page_NotificationTemplate_List", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["subject"]
      },
      search_params: {
        any: "",
        name: "",
        status: 1
      }
    }
  },

  computed: {
    headers: {
      get() {
        return [
          { text: this.$t("notificationtemplates.subject"), value: "subject" },
          { text: this.$t("notificationtemplates.slug"), value: "slug" },
          { text: this.$t("notificationtemplates.trigger"), value: "trigger" },
          { text: this.$t("notificationtemplates.type"), value: "type" },
          { text: this.$t("global.updated"), value: "updated_at" },
          {
            text: this.$t("global.actions"),
            value: "actions",
            width: "10%",
            align: "end",
            sortable: false
          }
        ]
      }
    },
    locale() {
      let locale = this.$getSetting("locale")
      return locale ? locale : "no"
    },
    computedTriggers() {
      let data = this.triggers

      if (this.locale == "no") {
        data.forEach((item, index) => {
          item.name = item.name_no
        })
      }

      return data
    }
  },

  watch: {
    refresh: {
      handler() {
        if (this.refresh) {
          localStorage.setItem("__notificationtemplateListSearchParams", JSON.stringify(this.search_params))
          this.list()
        }
      }
    },
    pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__page_NotificationTemplate_List", newVal.page)
          }

          this.refresh = true
        }
      }
    }
  },

  mounted() {
    this.url = this.API_URL + "notificationtemplates"
    if (localStorage.getItem("__notificationtemplateListSearchParams")) {
      this.search_params = JSON.parse(localStorage.getItem("__notificationtemplateListSearchParams"))
    }
  },

  created() {
    this.ddlists()
  },

  methods: {
    list() {
      this.show_loading = true

      let { sortBy, descending, page, itemsPerPage } = this.pagination
      let query = this.$queryString(this.pagination, this.search_params)

      axios.get(this.url + "?" + query).then((res) => {
        this.notificationtemplates = res.data.data
        this.total = res.data.meta.total
        this.refresh = false
        this.show_loading = false

        this.pagination.page = res.data.meta.current_page
        this.pagination.itemsPerPage = Number(res.data.meta.per_page)
      })
    },

    ddlists() {
      let lists = [{ key: "notificationtemplatestriggers", module: "notificationtemplatestriggers", query: "" }]

      axios.post(this.API_URL + "request/ddlists", lists).then((res) => {
        this.triggers = res.data.notificationtemplatestriggers
      })
    },

    getTriggerName(slug) {
      let obj = this.computedTriggers.find((i) => i.slug == slug)
      return obj ? obj.name : null
    },

    filter(target) {
      this.pagination.page = 1
      this.refresh = true
    },

    reset() {
      this.$refs.form.reset()
      this.pagination.page = 1
      this.refresh = true
    },

    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "notificationtemplate/" + id)
            .then((res) => {
              vm.refresh = true
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },

    checkKeyPress(e) {
      if (e.key == "Enter") {
        this.filter()
      }
    }
  }
}
</script>

<style scoped></style>
